import {Injectable} from '@angular/core';
import {ERROR_CODES} from 'src/app/domain/error/error-codes';
import ValidationError from 'src/app/domain/error/validation-error';
import {AbstractValidator} from 'src/app/domain/validators/validator';

@Injectable({
  providedIn: 'root'
})
export class NameValidator extends AbstractValidator {
  errorLabel?: string = null;

  isValid(value: string | null): boolean {
    return super.isValid(value);
  }

  setErrorLabel(label: string): NameValidator {
    this.errorLabel = label;
    return this;
  }

  validate(value: string | null): void {
    if (/^.{2,}\s*([A-Za-záéíóúäëïöüÑñ]{1,}([\.,] |[-']| ))*[A-Za-záéíóúäëïöüÑñ]+\.?\s*$/.test(value)) {
      return;
    }

    throw new ValidationError(ERROR_CODES.invalidName, this.errorLabel? this.errorLabel : 'shared.errors.invalidName');
  }
}
